angular.module('unergie.main')
.filter('readingOrigin', ($sce) =>
    _.memoize((val) => {
        let text = val
        let title
        switch (val) {
            case ' ': text = `Relève transmise dans le cas d'un Redressement de Facture`
                break
            case 'A': text = `Client absent`
                title = `La relève n'a pas pu être effectuée car le client était absent. Si le client ne fournit pas sa relève, elle est estimée par Enedis.`
                break
            case 'B': text = `Saut de relevé`
                title = `La relève n'a pas été effectuée par Enedis suite à un empêchement (intempérie,  indisponibilité technicien..etc.)`
                break
            case 'C': text = `Relève estimée car relève réelle invalide`
                break
            case 'D': text = `Relève estimée car relève réelle manquante`
                break
            case 'E': text = `Index de mise en service, calculé dans la transaction de changement de fournisseur Changement de tarif TURP2 dans la transaction modification de PDL.`
                break
            case 'F': text = `Index de résiliation, calculé dans la transaction de changement de fournisseur`
                break
            case 'G': text = `Index de changement de responsable d'équilibre (ancienne et nouvelle situation), calculé`
                break
            case 'H': text = `Index de changement de responsable d'équilibre (ancienne et nouvelle situation), relevé par le fournisseur`
                break
            case 'I': text = `Relève intermédiaire estimée`
                break
            case 'K': text = `Rectification au fichier abonnés d'un index "départ de facturation"`
                break
            case 'N': text = `Relevé normal`
                break
            case 'O': text = `Auto relevé dans la fenêtre de facturation`
                title = `Le client renvoie la carte laissée par le releveur, la prise en compte est celle donnée par le client`
                break
            case 'P': text = `Ouverture de contrat (MES ou CFN)`
                break
            case 'Q': text = `Auto-relève`
                break
            case 'R': text = `Relève de résiliation`
                break
            case 'S': text = `Relevé spécial`
                break
            case 'T': text = `Changement de d'option tarifaire`
                break
            case 'U': text = `Changement de débit`
                break
            case 'V': text = `Changement de compteur`
                break
            case 'W': text = `Changement de puissance souscrite`
                break
            case 'X': text = `Auto-relève`
                break
            case 'Y': text = `Relève de résiliation`
                break
            case 'Z': text = `Relève de départ venant du fournisseur`
                break
            default:
        }
        const result = `<span>${text}&nbsp;${title ? `<span class="fa fa-question-circle cursor-help" title="${title}"></span>` : ''}</span>`
        return $sce.trustAsHtml(result)
    })
)
